import { UsuarioPerfil } from '../api/ords/model';
import { UserKeyclaokPermission } from './service/papel';

type PerfilConferido = Pick<UsuarioPerfil, 'cd_papel_acesso' | 'ib_operadora' | 'operadoras_vinculadas'>;

/**
 * Diferenças entre o perfil (`GET geral/perfil`) e os grupos do token do Keycloak, uma frase por
 * eixo. O perfil é a fonte: o front decide o acesso por ele e pelas funcionalidades, então a
 * divergência só é registrada, nunca corrigida nem bloqueante. Ela costuma indicar grupo não
 * atualizado no Keycloak, ou um token emitido antes da mudança e ainda não renovado.
 *
 * - **Papel:** o token deve ter um só grupo `/PAPEL`, igual ao `cd_papel_acesso` do perfil.
 * - **Operadoras:** só para papel que admite vínculo (`ib_operadora = 1`, o que inclui o
 *   Convidado); os grupos `/OPERADORA` devem ser os vínculos do perfil, em qualquer ordem.
 */
export function divergenciasPerfilToken(perfil: PerfilConferido, token: UserKeyclaokPermission): string[] {
  const divergencias: string[] = [];

  const papelPerfil = perfil.cd_papel_acesso?.toUpperCase() ?? null;
  if (token.papeis.length > 1) {
    divergencias.push(`Token com mais de um papel - IDSS: [${papelPerfil}] | Token: [${token.papeis.join(',')}]`);
  } else if ((token.papeis[0] ?? null) !== papelPerfil) {
    divergencias.push(`Papel divergente - IDSS: [${papelPerfil}] | Token: [${token.papeis[0] ?? null}]`);
  }

  if (perfil.ib_operadora === 1) {
    const operadorasPerfil = (perfil.operadoras_vinculadas ?? []).map(op => op.cd_registro_ans);
    const mesmas =
      operadorasPerfil.length === token.operadoras.length &&
      operadorasPerfil.every(cd => token.operadoras.includes(cd));
    if (!mesmas) {
      divergencias.push(
        `Operadoras divergentes - IDSS: [${operadorasPerfil.join(',')}] | Token: [${token.operadoras.join(',')}]`,
      );
    }
  }

  return divergencias;
}
